import { render, staticRenderFns } from "./WriteTouristMsg.vue?vue&type=template&id=11ce2b7c&scoped=true&"
import script from "./WriteTouristMsg.vue?vue&type=script&lang=js&"
export * from "./WriteTouristMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ce2b7c",
  null
  
)

export default component.exports